import { FC, MouseEvent, useCallback, useState } from 'react'
import { useDisabledStyles } from '@components/styles'
import { MailIcon, tss, Menu } from '@ds/components'
import { TabBarItem } from '@components/header/TabBar'
import EnhancedLink from '@components/EnhancedLink'

const useStyles = tss.create(({ theme }) => ({
    offCanvasMenuItem: {
        textDecoration: 'none',
        display: 'block',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        fontFamily: 'Bryant, sans-serif',
        lineHeight: theme.spacing(5.625),
        fontSize: theme.spacing(1.625),
        fontWeight: 600,
        letterSpacing: theme.spacing(-0.01125),
        textTransform: 'uppercase',
        color: '#0e3247',
        cursor: 'pointer',
        backgroundColor: 'transparent',
        width: '100%',
        border: 'none',
        textAlign: 'left',
        '&:focus': {
            outline: 'none',
        },
        '&:hover': {
            backgroundColor: 'rgba(30, 112, 161, 0.04)', // action.hover
            textDecoration: 'none',
        },
        '& + &': {
            borderTop: '1px solid #e6e6e6',
        },
    },
    menu: {
        '& .MuiMenu-paper': {
            minWidth: 160,
        },
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'inline-flex',
        },
    },
}))

const MenuListProps = { disablePadding: true } as const
const anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
} as const
const transformOrigin = {
    vertical: 'top',
    horizontal: 'right',
} as const

const subscriptionRenewal = '/subscription/renewal'

export const DesktopMessagesMenu: FC<{ className?: string; hardDunning?: boolean }> = ({ className, hardDunning }) => {
    const { classes } = useStyles()
    const { cx } = useDisabledStyles()
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const handleClick = (event: MouseEvent<HTMLElement>) => {
        event.preventDefault()
        setAnchorEl(event.currentTarget)
    }
    const handleClose = useCallback(() => setAnchorEl(null), [])
    const onInboxClick = useCallback((e: MouseEvent<HTMLElement>) => {
        handleClick(e)
    }, [])

    return (
        <>
            <TabBarItem
                className={className}
                testId="inboxMenuTrigger"
                Icon={MailIcon}
                route="/inbox"
                spaceLeft
                onClick={onInboxClick}
                aria-controls="messages-menu"
                aria-haspopup="true"
                desktopOnly
            >
                Inbox
            </TabBarItem>
            <Menu
                id="messages-menu"
                data-testid="messagesMenu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                MenuListProps={MenuListProps}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
                className={cx(classes.menu, className)}
            >
                <EnhancedLink
                    to={hardDunning ? subscriptionRenewal : 'https://www.internations.org/inbox?ref=he_msg'}
                    className={classes.offCanvasMenuItem}
                    onClick={handleClose}
                >
                    Message
                </EnhancedLink>
                <EnhancedLink
                    to={hardDunning ? subscriptionRenewal : 'https://www.internations.org/say-hi?ref=he_hi'}
                    className={classes.offCanvasMenuItem}
                    onClick={handleClose}
                >
                    Members saying hi!
                </EnhancedLink>
            </Menu>
        </>
    )
}
